export default {
  color1: '#e7e7e7',
  color2: '#9696A6',
  border_color: '#2A2A3D',
  bg_color1: '#1c1c28',
  bg_color2: '#121a31',
  bg_color: '#1c1c28',
  tab_bg_color: '#2c2c42',
  text_clolor: '#9696A6',
  toast_text: '#e7e7e7',
  toast_bg_color: '#2c2c42',
  active_bg_color: '#1c1c28',
  card_bg_color: '#2c2c42',
  activity_state_color: '#e7e7e7',
  nodata_img: require(`@/img/user-new/dark_no_data.png`),
  box_shadow: 'none',
  invite_bg: 'none',
  invite_text: '#fff',
  invite_card_bg: 'linear-gradient(0deg, #1C1B27 0%, #885959 100%)',
  ellipsis_color: '#243256',
  loading_img: require('@/img/loading-psd.gif'),
}


// WEBPACK FOOTER //
// ./src/styles/dark.js